var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.27681",
      "conversations-internal-schema": "static-1.13266",
      "head-dlb": "static-1.5007",
      "hs-test-utils": "static-1.8235",
      "hubspot-url-utils": "static-1.4282",
      "HubStyleTokens": "static-2.11684",
      "I18n": "static-7.1651",
      "jasmine-runner": "static-1.6664",
      "quartz": "static-1.7309",
      "react": "static-7.190",
      "reselect": "static-3.8",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.491",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6355",
      "enviro": "static-4.455",
      "hs-promise-rejection-tracking": "static-1.5587",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "raven-hubspot": "static-1.6232",
      "bend-plugin-trellis-migration": "static-1.3545",
      "moment": "static-3.26",
      "customer-data-email": "static-1.18397",
      "cv-backend-services": "static-1.1589",
      "hub-http": "static-1.6427",
      "immutable": "static-2.83",
      "immutable-less": "static-1.4860",
      "quartz-config": "static-1.1087",
      "quartz-core": "static-1.6528",
      "transmute": "static-2.85",
      "HeadJS": "static-2.782",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.8319",
      "framer-motion": "static-1.75",
      "hs-test-utils-bend-plugin": "static-1.3346",
      "msw": "static-1.39",
      "react-redux": "static-7.75",
      "redux": "static-4.16",
      "testing-library": "static-1.155",
      "foundations-theming": "static-1.4654",
      "i18n-data": "static-1.225",
      "metrics-js": "static-1.9849",
      "moment-timezone": "static-5.86",
      "react-utils": "static-2.5487",
      "jasmine": "static-4.4533",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.3107",
      "react-aria": "static-1.69",
      "styled-components": "static-2.94",
      "UIComponents": "static-3.8630",
      "visitor-ui-component-library-icons": "static-1.6166",
      "bender-build-tools": "static-1.3323",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4864",
      "apollo-stack-hubspot": "static-3.89",
      "classnames": "static-2.10",
      "cssUtils": "static-1.855",
      "customer-data-objects": "static-1.7892",
      "customer-data-ui-utilities": "static-1.10034",
      "data-fetching-client": "static-1.9867",
      "FileManagerCore": "static-1.39733",
      "FileManagerLib": "static-1.39874",
      "foundations-assets": "static-1.5085",
      "graphql": "static-1.85",
      "hs-promise-utils": "static-1.5803",
      "hubspot-apollo-client": "static-1.5087",
      "icons": "static-2.668",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.108",
      "react-virtualized": "static-2.102",
      "rpc-client-utils": "static-1.4868",
      "salesImages": "static-1.529",
      "timezone-utils": "static-2.5454",
      "ui-gdpr-components": "static-1.10560",
      "ts-schema": "static-1.4226",
      "hs-locale-management": "static-1.227",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.140",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.859",
      "hubspotter-http": "static-1.4797",
      "mobile-manifest-mixins": "static-1.556",
      "module-federation": "static-1.29",
      "quartz-auth": "static-1.984",
      "quartz-head": "static-1.974",
      "quartz-i18n": "static-1.984",
      "quartz-routing": "static-1.739",
      "quartz-test": "static-1.984",
      "quartz-tracking": "static-1.688",
      "quick-fetch": "static-1.4063",
      "react-rhumb": "static-1.16913",
      "trellis-components": "static-1.2374",
      "ui-fonts": "static-1.946",
      "usage-tracker-container": "static-1.7552",
      "usage-tracker-core": "static-1.7412",
      "bend-plugin-foundations-components": "static-1.4588",
      "floating-ui": "static-1.60",
      "foundations-theming-specialty": "static-1.2370",
      "hs-story-utils": "static-1.9635",
      "react-create-root-preference": "static-1.51",
      "tanstack-table": "static-1.58",
      "trellis-assets": "static-1.2355",
      "ui-images": "static-2.1215",
      "bend-plugin-foundations-theming": "static-1.3137",
      "foundations-theming-base": "static-1.3639",
      "stylex": "static-1.37",
      "HubStyle": "static-2.11991",
      "sassPrefix": "static-1.160",
      "inbound-db-properties-service-client": "static-1.3991",
      "property-translator": "static-1.5605",
      "react-dnd-compat": "static-1.4824",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.9477",
      "audio-components": "static-1.6219",
      "ContentUtils": "static-1.68959",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29672",
      "file-manager-components": "static-1.24234",
      "FileManagerImages": "static-1.37385",
      "foundations-components-legacy": "static-1.1344",
      "html-to-image": "static-1.57",
      "immerable": "static-1.4358",
      "react-colorpicker": "static-2.10419",
      "redux-toolkit": "static-1.7",
      "ui-universal-auth": "static-1.9229",
      "urlinator": "static-1.4742",
      "video-components": "static-1.13939",
      "video-data-lib": "static-1.35595",
      "video-embed": "static-1.36429",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.546",
      "bend-plugin-chirp-manifest": "static-1.278",
      "chirp-fetch": "static-1.2097",
      "hub-http-shared-msw-handlers": "static-1.10457",
      "hubspotter-http-shared-msw-handlers": "static-1.10455",
      "usage-tracker-session-replay": "static-1.5248",
      "web-vitals": "static-1.9",
      "base-ui": "static-1.17",
      "react-day-picker": "static-1.6",
      "trellis-theming": "static-1.1163",
      "tanstack-virtual": "static-1.33",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.22368",
      "copilot-toolkit": "static-1.11663",
      "customer-data-objects-ui-components": "static-1.13240",
      "sanitize": "static-1.4687",
      "sanitize-text": "static-1.8357",
      "content-assistance-lib": "static-1.8069",
      "usage-tracker": "static-1.7562",
      "cms-field-types": "static-1.5025",
      "content-icons-ui": "static-1.2291",
      "integrations-lib": "static-1.16802",
      "underscore": "static-1.8",
      "breeze-engine-lib": "static-1.1450",
      "ui-addon-iframeable": "static-1.9283",
      "video-components-external": "static-1.11937",
      "unified-auth-core-lib": "static-1.1025",
      "social-insights-client-types": "static-1.22606",
      "SharedI18nStrings": "static-1.182",
      "outpost": "static-1.4374",
      "amplitude-session-replay-browser": "static-1.60",
      "markdown-it": "static-1.6",
      "magpie-lib": "static-1.5699",
      "magpie-types": "static-1.5159",
      "simple-logging-lib": "static-1.3259",
      "atom": "static-1.5286",
      "avatar-components": "static-1.2707",
      "reference-resolvers": "static-1.8387",
      "superstore": "static-1.4968",
      "ui-addon-video-player": "static-1.8916",
      "ui-coaching-tips": "static-1.29130",
      "flux-actions": "static-1.355",
      "frontend-preferences-client": "static-1.8136",
      "integrations-error-boundary-lib": "static-1.14217",
      "integrations-tracking-lib": "static-1.5817",
      "laboratory-lib": "static-3.7361",
      "native-integrations-shared-strings": "static-1.7986",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10575",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11357",
      "ui-shepherd-react": "static-3.10471",
      "unified-auth": "static-1.743",
      "breeze-engine-chat-components": "static-1.428",
      "breeze-engine-core": "static-1.728",
      "ably": "static-2.2",
      "highlight.js": "static-1.82",
      "navigation-messaging": "static-1.7948",
      "content-media-composition-data-lib": "static-1.12977",
      "content-media-compositions": "static-2.16984",
      "idb-keyval": "static-1.47",
      "media-bridge-lib": "static-1.19278",
      "fsm": "static-1.3942",
      "reactive-lib": "static-1.932",
      "growth-onboarding-feedback-components": "static-1.6791",
      "universal-page-editor-lib": "static-1.3221",
      "foundations-components-test-utils": "static-1.5802",
      "adobe-sign-auth-lib": "static-1.263",
      "ads-unified-auth-lib": "static-1.792",
      "google-sheets-integration-lib": "static-1.840",
      "microsoft-drive-integration-lib": "static-1.957",
      "surveymonkey-integration-lib": "static-1.284",
      "slack-ui-library": "static-1.10609",
      "js-cookie": "static-1.18",
      "react-dlb": "static-1.83",
      "crm-record-cards-service-types": "static-1.3730",
      "framework-data-schema-resolvers": "static-1.7104",
      "location-customization-utils-lib": "static-1.9887",
      "batch-promise": "static-1.1754",
      "conditional-properties-service-client": "static-1.3943",
      "crm-pipelines-api-client-types": "static-1.4282",
      "fdsr-migration-layer": "static-1.223",
      "framework-builder-read-service-client": "static-1.4152",
      "framework-data-schema-quick-fetch": "static-1.7009",
      "inbound-db-meta-service-client": "static-1.3718",
      "multi-currency-client-types": "static-1.3837",
      "persist-promise": "static-1.3911"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.27681",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13266",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-test-utils": "/hs-test-utils/static-1.8235",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4282",
      "HubStyleTokens": "/HubStyleTokens/static-2.11684",
      "I18n": "/I18n/static-7.1651",
      "jasmine-runner": "/jasmine-runner/static-1.6664",
      "quartz": "/quartz/static-1.7309",
      "react": "/react/static-7.190",
      "reselect": "/reselect/static-3.8",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.491",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6355",
      "enviro": "/enviro/static-4.455",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3545",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.18397",
      "cv-backend-services": "/cv-backend-services/static-1.1589",
      "hub-http": "/hub-http/static-1.6427",
      "immutable": "/immutable/static-2.83",
      "immutable-less": "/immutable-less/static-1.4860",
      "quartz-config": "/quartz-config/static-1.1087",
      "quartz-core": "/quartz-core/static-1.6528",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.782",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.8319",
      "framer-motion": "/framer-motion/static-1.75",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3346",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.75",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.155",
      "foundations-theming": "/foundations-theming/static-1.4654",
      "i18n-data": "/i18n-data/static-1.225",
      "metrics-js": "/metrics-js/static-1.9849",
      "moment-timezone": "/moment-timezone/static-5.86",
      "react-utils": "/react-utils/static-2.5487",
      "jasmine": "/jasmine/static-4.4533",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.3107",
      "react-aria": "/react-aria/static-1.69",
      "styled-components": "/styled-components/static-2.94",
      "UIComponents": "/UIComponents/static-3.8630",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6166",
      "bender-build-tools": "/bender-build-tools/static-1.3323",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4864",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.855",
      "customer-data-objects": "/customer-data-objects/static-1.7892",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10034",
      "data-fetching-client": "/data-fetching-client/static-1.9867",
      "FileManagerCore": "/FileManagerCore/static-1.39733",
      "FileManagerLib": "/FileManagerLib/static-1.39874",
      "foundations-assets": "/foundations-assets/static-1.5085",
      "graphql": "/graphql/static-1.85",
      "hs-promise-utils": "/hs-promise-utils/static-1.5803",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5087",
      "icons": "/icons/static-2.668",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.108",
      "react-virtualized": "/react-virtualized/static-2.102",
      "rpc-client-utils": "/rpc-client-utils/static-1.4868",
      "salesImages": "/salesImages/static-1.529",
      "timezone-utils": "/timezone-utils/static-2.5454",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10560",
      "ts-schema": "/ts-schema/static-1.4226",
      "hs-locale-management": "/hs-locale-management/static-1.227",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.140",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.859",
      "hubspotter-http": "/hubspotter-http/static-1.4797",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.556",
      "module-federation": "/module-federation/static-1.29",
      "quartz-auth": "/quartz-auth/static-1.984",
      "quartz-head": "/quartz-head/static-1.974",
      "quartz-i18n": "/quartz-i18n/static-1.984",
      "quartz-routing": "/quartz-routing/static-1.739",
      "quartz-test": "/quartz-test/static-1.984",
      "quartz-tracking": "/quartz-tracking/static-1.688",
      "quick-fetch": "/quick-fetch/static-1.4063",
      "react-rhumb": "/react-rhumb/static-1.16913",
      "trellis-components": "/trellis-components/static-1.2374",
      "ui-fonts": "/ui-fonts/static-1.946",
      "usage-tracker-container": "/usage-tracker-container/static-1.7552",
      "usage-tracker-core": "/usage-tracker-core/static-1.7412",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4588",
      "floating-ui": "/floating-ui/static-1.60",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2370",
      "hs-story-utils": "/hs-story-utils/static-1.9635",
      "react-create-root-preference": "/react-create-root-preference/static-1.51",
      "tanstack-table": "/tanstack-table/static-1.58",
      "trellis-assets": "/trellis-assets/static-1.2355",
      "ui-images": "/ui-images/static-2.1215",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3137",
      "foundations-theming-base": "/foundations-theming-base/static-1.3639",
      "stylex": "/stylex/static-1.37",
      "HubStyle": "/HubStyle/static-2.11991",
      "sassPrefix": "/sassPrefix/static-1.160",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3991",
      "property-translator": "/property-translator/static-1.5605",
      "react-dnd-compat": "/react-dnd-compat/static-1.4824",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9477",
      "audio-components": "/audio-components/static-1.6219",
      "ContentUtils": "/ContentUtils/static-1.68959",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29672",
      "file-manager-components": "/file-manager-components/static-1.24234",
      "FileManagerImages": "/FileManagerImages/static-1.37385",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1344",
      "html-to-image": "/html-to-image/static-1.57",
      "immerable": "/immerable/static-1.4358",
      "react-colorpicker": "/react-colorpicker/static-2.10419",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "ui-universal-auth": "/ui-universal-auth/static-1.9229",
      "urlinator": "/urlinator/static-1.4742",
      "video-components": "/video-components/static-1.13939",
      "video-data-lib": "/video-data-lib/static-1.35595",
      "video-embed": "/video-embed/static-1.36429",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.546",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.278",
      "chirp-fetch": "/chirp-fetch/static-1.2097",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10457",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10455",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5248",
      "web-vitals": "/web-vitals/static-1.9",
      "base-ui": "/base-ui/static-1.17",
      "react-day-picker": "/react-day-picker/static-1.6",
      "trellis-theming": "/trellis-theming/static-1.1163",
      "tanstack-virtual": "/tanstack-virtual/static-1.33",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.22368",
      "copilot-toolkit": "/copilot-toolkit/static-1.11663",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13240",
      "sanitize": "/sanitize/static-1.4687",
      "sanitize-text": "/sanitize-text/static-1.8357",
      "content-assistance-lib": "/content-assistance-lib/static-1.8069",
      "usage-tracker": "/usage-tracker/static-1.7562",
      "cms-field-types": "/cms-field-types/static-1.5025",
      "content-icons-ui": "/content-icons-ui/static-1.2291",
      "integrations-lib": "/integrations-lib/static-1.16802",
      "underscore": "/underscore/static-1.8",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1450",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9283",
      "video-components-external": "/video-components-external/static-1.11937",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1025",
      "social-insights-client-types": "/social-insights-client-types/static-1.22606",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "outpost": "/outpost/static-1.4374",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "markdown-it": "/markdown-it/static-1.6",
      "magpie-lib": "/magpie-lib/static-1.5699",
      "magpie-types": "/magpie-types/static-1.5159",
      "simple-logging-lib": "/simple-logging-lib/static-1.3259",
      "atom": "/atom/static-1.5286",
      "avatar-components": "/avatar-components/static-1.2707",
      "reference-resolvers": "/reference-resolvers/static-1.8387",
      "superstore": "/superstore/static-1.4968",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8916",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29130",
      "flux-actions": "/flux-actions/static-1.355",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8136",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14217",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5817",
      "laboratory-lib": "/laboratory-lib/static-3.7361",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7986",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10575",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11357",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10471",
      "unified-auth": "/unified-auth/static-1.743",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.428",
      "breeze-engine-core": "/breeze-engine-core/static-1.728",
      "ably": "/ably/static-2.2",
      "highlight.js": "/highlight.js/static-1.82",
      "navigation-messaging": "/navigation-messaging/static-1.7948",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12977",
      "content-media-compositions": "/content-media-compositions/static-2.16984",
      "idb-keyval": "/idb-keyval/static-1.47",
      "media-bridge-lib": "/media-bridge-lib/static-1.19278",
      "fsm": "/fsm/static-1.3942",
      "reactive-lib": "/reactive-lib/static-1.932",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6791",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3221",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5802",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.263",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.792",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.840",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.957",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.284",
      "slack-ui-library": "/slack-ui-library/static-1.10609",
      "js-cookie": "/js-cookie/static-1.18",
      "react-dlb": "/react-dlb/static-1.83",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3730",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7104",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9887",
      "batch-promise": "/batch-promise/static-1.1754",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3943",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4282",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.223",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4152",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7009",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3837",
      "persist-promise": "/persist-promise/static-1.3911"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.27681",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};